import { Injectable } from '@angular/core';

import {
  DURACAO_SOM_TRANSICAO_AUDIO_MS, NOTAS_SOM_TRANSICAO_AUDIO, VOLUME_SOM_TRANSICAO_AUDIO
} from '../util/som-transicao-audio.constantes';

@Injectable({ providedIn: 'root' })
export class SomTransicaoAudioService {
  private contexto?: AudioContext;

  tocar(): Promise<void> {
    try {
      this.contexto ??= new AudioContext();
      const contexto = this.contexto;
      if (contexto.state === 'suspended') contexto.resume();
      const agora = contexto.currentTime;
      for (const nota of NOTAS_SOM_TRANSICAO_AUDIO) {
        const oscilador = contexto.createOscillator();
        const ganho = contexto.createGain();
        oscilador.type = 'sine';
        oscilador.frequency.value = nota.frequencia;
        ganho.gain.setValueAtTime(0.0001, agora + nota.inicio);
        ganho.gain.exponentialRampToValueAtTime(VOLUME_SOM_TRANSICAO_AUDIO, agora + nota.inicio + 0.02);
        ganho.gain.exponentialRampToValueAtTime(0.0001, agora + nota.inicio + nota.duracao);
        oscilador.connect(ganho).connect(contexto.destination);
        oscilador.start(agora + nota.inicio);
        oscilador.stop(agora + nota.inicio + nota.duracao);
      }
    } catch {
      this.contexto = undefined;
    }
    return new Promise(resolve => setTimeout(resolve, DURACAO_SOM_TRANSICAO_AUDIO_MS));
  }
}
